/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { Row } from 'react-bootstrap';

import { certificationServiceStatus } from '../../../../../constants/constants';
import { checkRol } from '../../../../../security';
import { inspector, proveedorNotificador } from '../../../../../security/constantsRols';
import { PositionLinePermissions } from '../../../../MonthlyServiceRequest/RequestDetailTypes';
import { workReportLineStatus } from '../../../../../utils/dataStatus';
import AmountInput from '../../../AmountInput/AmountInput';
import CommentsWorkReportButton from '../../../WorkReportActionButtons/CommentsWorkReportButton/CommentsWorkReportButton';
import InspectWorkReportButton from '../../../WorkReportActionButtons/InspectWorkReport/InspectWorkReportButton';
import SendToApproveButton from '../../../WorkReportActionButtons/SendToApproveButton/SendToApproveButton';
import FilesWorkReportButton from '../../../WorkReportActionButtons/FilesWorkReportButton/FilesWorkReportButton';
import '../WeeklyView.scss';
import ComponentWithTooltip from '../../../../ComponentWithTooltip/ComponentWithTooltip';
import { validateOnlyDecimalInput } from '../../../../../utils/formatUtils';

const DailyReport = (props) => {
  const {
    workReportId,
    dailyReport,
    enableNotification,
    setChangeInLine,
    changeInLine,
    startDate,
    indexPosition,
    selectedDate,
    indexLine,
    indexWorkReport,
    newFetch,
    setNewFetch,
    positionLinesPermissions,
    typeOfUbication,
    disabledEditStateCancelOrFinish,
    isOyM,
    line
  } = props;

  const isWindowOpen = dailyReport.ventanaActiva;

  const { setFieldValue, values } = useFormikContext();

  const lineToApprove = {
    ...values?.position[indexPosition]?.lineas[indexLine]?.partesDiarios[indexWorkReport],
    idParteDiario:
      values?.position[indexPosition]?.lineas[indexLine]?.partesDiarios[indexWorkReport]?.id,
    cantidad:
      values?.position[indexPosition]?.lineas[indexLine]?.partesDiarios[indexWorkReport]?.cantidad
  };

  const isNotifyingProviderRole = checkRol(proveedorNotificador);
  const isLineBlockedBySap = line?.bloqueadoEnSap && isNotifyingProviderRole;

  const showInspectWorkReportButton =
    (dailyReport.disabled && dailyReport.estadoEnum !== workReportLineStatus.enviar) ||
    checkRol(inspector);

  const showSendToApproveButton =
    (!dailyReport.disabled || dailyReport.estadoEnum === workReportLineStatus.enviar) &&
    !checkRol(inspector);

  const lineIsRejectedAndAproved =
    dailyReport?.estadoRevision?.estadoCertEnum === certificationServiceStatus.reject &&
    dailyReport?.estadoEnum === workReportLineStatus.aprobar;

  const lineCommnets = {
    ...dailyReport,
    positionName: `${dailyReport.numeroPosicion} - ${dailyReport.descripcionPosicionSap}`,
    lineName: `${dailyReport.numeroLinea} - ${dailyReport.descripcionLineaSap}`,
    idParteDiario: dailyReport.id,
    unidadMedida: values?.position[indexPosition]?.lineas[indexLine]?.unidadMedida,
    disabled: dailyReport.disabled
  };

  const onChange = (val) => {
    const { value } = val.target;

    if (validateOnlyDecimalInput(value, 5)) {
      setFieldValue(
        `position[${indexPosition}].lineas[${indexLine}].partesDiarios[${indexWorkReport}].cantidad`,
        value
      );
    } else if (value === '') {
      setFieldValue(
        `position[${indexPosition}].lineas[${indexLine}].partesDiarios[${indexWorkReport}].cantidad`,
        null
      );
    }
    setChangeInLine(!changeInLine);
  };

  const DayTag = () => (
    <p className="weekly_report_font">
      {dailyReport?.nombreDia?.substring(0, 3).toUpperCase()} {dailyReport?.numeroDia}
    </p>
  );

  return (
    <div className="daily_report_by_week">
      <Row className="align-items-baseline">
        <div
          className={`weekly_report_date ${
            !isOyM && !isWindowOpen ? 'out-notification' : 'normal'
          }`}
        >
          {!isOyM && !isWindowOpen ? (
            <ComponentWithTooltip tooltipText="Fecha fuera de la ventana de notificación">
              {DayTag()}
            </ComponentWithTooltip>
          ) : (
            DayTag()
          )}
        </div>
        <div
          style={{
            width: '20%',
            paddingRight: '10%'
          }}
        >
          <FilesWorkReportButton
            canAttachFiles={positionLinesPermissions.attachedFiles.write}
            canVisualizeFiles={positionLinesPermissions.attachedFiles.visualize}
            disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
            line={{
              ...lineCommnets,
              bloqueadoEnSap: isLineBlockedBySap
            }}
            setNewFetch={setNewFetch}
            startDate={startDate}
          />
        </div>
        <div
          style={{
            width: '20%'
          }}
        >
          <CommentsWorkReportButton
            canSendComments={
              positionLinesPermissions.comments.write && !disabledEditStateCancelOrFinish
            }
            canVisualizeComments={positionLinesPermissions.comments.visualize}
            line={{
              ...lineCommnets,
              bloqueadoEnSap: isLineBlockedBySap
            }}
            startDate={startDate}
          />
        </div>
      </Row>
      <div className="weekly_imput_amount_wrapper">
        <div>
          <AmountInput
            disabled={lineIsRejectedAndAproved || !enableNotification || isLineBlockedBySap}
            disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
            line={{
              ...dailyReport
            }}
            onChange={onChange}
            value={
              values?.position[indexPosition]?.lineas[indexLine]?.partesDiarios[indexWorkReport]
                ?.cantidad
            }
          />
        </div>
        <div>
          {showInspectWorkReportButton ? (
            <InspectWorkReportButton
              className="inspector_work_button_weekly"
              disabled={
                !positionLinesPermissions.expertReview.actionInspectorButton || isLineBlockedBySap
              }
              line={{
                ...dailyReport
              }}
              setNewFetch={setNewFetch}
              typeOfUbication={typeOfUbication}
            />
          ) : null}
          {showSendToApproveButton ? (
            <SendToApproveButton
              amount={
                values?.position[indexPosition]?.lineas[indexLine]?.partesDiarios[indexWorkReport]
                  ?.cantidad
              }
              changeInLines={changeInLine}
              disabled={
                dailyReport.disabled ||
                !positionLinesPermissions.sendToApprove ||
                !values?.position[indexPosition]?.lineas[indexLine]?.partesDiarios[indexWorkReport]
                  ?.cantidad ||
                isLineBlockedBySap
              }
              line={{
                ...lineToApprove,
                blockedBySap: isLineBlockedBySap
              }}
              newFetch={newFetch}
              selectedDate={selectedDate}
              setChangeInLines={setChangeInLine}
              setNewFetch={setNewFetch}
              workReportId={workReportId}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

DailyReport.propTypes = {
  changeInLine: PropTypes.bool.isRequired,
  dailyReport: PropTypes.any.isRequired,
  enableNotification: PropTypes.bool.isRequired,
  indexLine: PropTypes.number.isRequired,
  indexPosition: PropTypes.number.isRequired,
  indexWorkReport: PropTypes.number.isRequired,
  newFetch: PropTypes.bool.isRequired,
  positionLinesPermissions: PositionLinePermissions.isRequired,
  selectedDate: PropTypes.string.isRequired,
  setChangeInLine: PropTypes.func.isRequired,
  setNewFetch: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  typeOfUbication: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string
  }).isRequired,
  workReportId: PropTypes.number.isRequired,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired,
  isOyM: PropTypes.bool,
  line: PropTypes.shape({
    bloqueadoEnSap: PropTypes.bool
  }).isRequired
};

DailyReport.defaultProps = {
  isOyM: false
};
export default DailyReport;
